export const dashboard = {
  metrics: {
    totalContent: {
      title: 'Total Contenido',
      description: 'Blogs completados',
    },
    generating: {
      title: 'Generando',
      description: 'En progreso actualmente',
    },
    successRate: {
      title: 'Tasa de Exito',
      description: 'Completados vs fallidos',
    },
    thisMonth: {
      title: 'Este Mes',
      description: 'Contenido creado',
    },
    avgPerWeek: {
      title: 'Prom / Semana',
      description: 'Ultimas 4 semanas',
    },
    failed: {
      title: 'Fallidos',
      description: 'Errores de generacion',
    },
  },
  recentContent: {
    title: 'Contenido Reciente',
    empty: 'Sin contenido aun',
    viewAll: 'Ver todo',
    status: {
      generating: 'Generando',
      completed: 'Completado',
      failed: 'Fallido',
    },
  },
  languageDistribution: {
    title: 'Idiomas',
    empty: 'Sin datos',
  },
  topKeywords: {
    title: 'Top Keywords',
    empty: 'Sin keywords aun',
  },
  quickActions: {
    newContent: 'Nuevo Contenido',
    viewContents: 'Mis Contenidos',
  },
  trend: {
    up: '+{{value}}% vs mes anterior',
    down: '{{value}}% vs mes anterior',
    neutral: 'Igual al mes anterior',
  },
  empty: {
    title: 'Sin contenido aun',
    description: 'Crea tu primer contenido para ver tu dashboard cobrar vida.',
    cta: 'Crear Contenido',
  },
  error: {
    title: 'Error cargando el dashboard',
    retry: 'Reintentar',
  },
} as const
